<template>
  <div class="container">
    <div v-if="event.pendingChangeRequest">
      <b-alert show variant="primary" class="mt-3">
        <span
          >A request was made to {{ event.changeRequestType }} this listing on {{ event.changeRequest.updated_at | dateAtTime }} by: <br />
          <b>{{ event.changeRequest.updated_by.first_name }} {{ event.changeRequest.updated_by.last_name }}</b>
          <br />
          {{ event.changeRequest.organization.name }}
          <br />
          {{ event.changeRequest.updated_by.telephone | telephoneNumber }} | {{ event.changeRequest.updated_by.email }}
          <br />
          <span v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor'">
            Please review the information in the PENDING tab to publish or reject the request. A notification will be sent to this member's organization upon completion.
          </span>
        </span>
        <br />
        <b-button size="sm" class="ml-3" @click="cancelChangeRequest(event.changeRequestId)">Cancel Change Request</b-button>
      </b-alert>
    </div>
    <div class="col-lg-12 text-left">
      <!-- <h1 class="text-center">{{ eventId ? 'Edit' : 'Create' }}</h1> -->
      <div class="row">
        <div class="col-lg-6">
          <h1>Event</h1>
          <b-form-group label="Organization *" label-for="name">
            <b-form-select id="org" name="org" v-model="event.organization_id" :state="submitted && $v.event.organization_id.$error ? false : null">
              <option value="">Select Organization</option>
              <option v-for="(org, index) in userOrgs" :value="org.value" :key="index">{{ org.text }}</option>
            </b-form-select>
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.organization_id.required">An organization is required</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Event Name *" label-for="name">
            <b-form-input
              v-model="event.name"
              id="name"
              name="name"
              placeholder="Event Name"
              @input="dirty = true"
              @change="generateSlug()"
              :state="submitted && $v.event.name.$error ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.name.required">Name is required</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Slug" label-for="slug" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor'">
            <b-form-input id="slug" name="slug" v-model="event.slug" type="text" @input="dirty = true" />
          </b-form-group>
          <b-form-group label="Social Networks" label-for="social-networks" v-if="$store.state.misc.social_networks">
            <div v-for="network in $store.state.misc.social_networks" :key="network.name">
              <b-input-group :prepend="network.base_url" class="mt-3">
                <b-form-input
                  v-if="event.social_networks && event.social_networks[network.name]"
                  v-model="event.social_networks[network.name].account_name"
                  @input="dirty = true"
                  :data-networkname="network.name"
                  :data-networkid="network._id"
                  ref="eventNetwork"
                ></b-form-input>
                <b-form-input v-else @input="dirty = true" :data-networkid="network._id" :data-networkname="network.name" ref="eventNetwork"></b-form-input>
              </b-input-group>
            </div>
          </b-form-group>
          <b-form-group label="Website" label-for="website">
            <b-form-input id="website" name="website" v-model="event.website" @input="dirty = true" />
            <b-form-invalid-feedback class="d-block red" v-if="this.event.website && !urlTest.test(this.event.website)">Must include http:// or https://</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Counties *" label-for="counties" v-if="event.counties">
            <b-form-select id="counties" name="counties" multiple v-model="event.counties" :state="submitted && $v.event.counties.$error ? false : null">
              <option value="Autauga">Autauga</option>
              <option value="Baldwin">Baldwin</option>
              <option value="Barbour">Barbour</option>
              <option value="Bibb">Bibb</option>
              <option value="Blount">Blount</option>
              <option value="Bullock">Bullock</option>
              <option value="Butler">Butler</option>
              <option value="Calhoun">Calhoun</option>
              <option value="Chambers">Chambers</option>
              <option value="Cherokee">Cherokee</option>
              <option value="Chilton">Chilton</option>
              <option value="Choctaw">Choctaw</option>
              <option value="Clarke">Clarke</option>
              <option value="Clay">Clay</option>
              <option value="Cleburne">Cleburne</option>
              <option value="Coffee">Coffee</option>
              <option value="Colbert">Colbert</option>
              <option value="Conecuh">Conecuh</option>
              <option value="Coosa">Coosa</option>
              <option value="Covington">Covington</option>
              <option value="Crenshaw">Crenshaw</option>
              <option value="Cullman">Cullman</option>
              <option value="Dale">Dale</option>
              <option value="Dallas">Dallas</option>
              <option value="DeKalb">DeKalb</option>
              <option value="Elmore">Elmore</option>
              <option value="Escambia">Escambia</option>
              <option value="Etowah">Etowah</option>
              <option value="Fayette">Fayette</option>
              <option value="Franklin">Franklin</option>
              <option value="Geneva">Geneva</option>
              <option value="Greene">Greene</option>
              <option value="Hale">Hale</option>
              <option value="Henry">Henry</option>
              <option value="Houston">Houston</option>
              <option value="Jackson">Jackson</option>
              <option value="Jefferson">Jefferson</option>
              <option value="Lamar">Lamar</option>
              <option value="Lauderdale">Lauderdale</option>
              <option value="Lawrence">Lawrence</option>
              <option value="Lee">Lee</option>
              <option value="Limestone">Limestone</option>
              <option value="Lowndes">Lowndes</option>
              <option value="Macon">Macon</option>
              <option value="Madison">Madison</option>
              <option value="Marengo">Marengo</option>
              <option value="Marion">Marion</option>
              <option value="Marshall">Marshall</option>
              <option value="Mobile">Mobile</option>
              <option value="Monroe">Monroe</option>
              <option value="Montgomery">Montgomery</option>
              <option value="Morgan">Morgan</option>
              <option value="Perry">Perry</option>
              <option value="Pickens">Pickens</option>
              <option value="Pike">Pike</option>
              <option value="Randolph">Randolph</option>
              <option value="Russell">Russell</option>
              <option value="St. Clair">St. Clair</option>
              <option value="Shelby">Shelby</option>
              <option value="Sumter">Sumter</option>
              <option value="Talladega">Talladega</option>
              <option value="Tallapoosa">Tallapoosa</option>
              <option value="Tuscaloosa">Tuscaloosa</option>
              <option value="Walker">Walker</option>
              <option value="Washington">Washington</option>
              <option value="Wilcox">Wilcox</option>
              <option value="Winston">Winston</option>
            </b-form-select>
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.counties.required">At least 1 county is required</b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <div>
            <div v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor'" class="availability-section">
              <h1>Availability</h1>
              <b-form-group label="Publish" label-for="publish">
                <b-form-radio-group id="publish" v-model="event.publish">
                  <b-form-radio value="None"><b>None</b><br />Is not displayed anywhere</b-form-radio>
                  <b-form-radio value="Limited"
                    ><b>Limited</b><br />
                    Only on the website</b-form-radio
                  >
                  <b-form-radio value="Everywhere"
                    ><b>Everywhere</b><br />
                    Available on the website &amp; apps</b-form-radio
                  >
                  <b-form-radio value="Everywhere + Featured"
                    ><b>Everywhere &amp; Featured</b><br />
                    Available on the website &amp; apps. Also used as featured content.</b-form-radio
                  >
                </b-form-radio-group>
              </b-form-group>
            </div>
            <h1>Venue</h1>
            <label>Location:</label>
            <autocomplete
              :source="locations"
              :results-display="formattedDisplay"
              placeholder="Search for an existing location"
              input-class="form-control"
              @selected="selectedLocation"
            >
            </autocomplete>
            <b-alert show variant="primary" class="mt-3" v-if="locationSelected.name != ''"
              >Selected Location: {{ locationSelected.name }}
              <b-button size="sm" @click="clearSelectedLocation()" class="btn btn-secondary">Clear Selected Location</b-button>
            </b-alert>
            <br />
            <br />
            <label>Address *</label>
            <gmap-autocomplete
              ref="address"
              @place_changed="setPlace"
              :value="event.venue.address || event.address"
              :selectFirstOnEnter="true"
              class="form-control"
              style="width: 100%"
              :state="submitted && ($v.event.venue.location.lat.$error || $v.event.venue.address.$error || $v.event.venue.zip.$error) ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && ($v.event.venue.location.lat.$error || $v.event.venue.address.$error || $v.event.venue.zip.$error)"
              >Something is wrong with the address, please try selecting it again.</b-form-invalid-feedback
            >
          </div>
          <gmap-map :center="map.center" :zoom="map.zoom" style="width: 100%; height: 400px; margin: 10px 0 10px 0">
            <gmap-marker v-if="event.venue.location.lat" :position="event.venue.location" @click="map.center = event.venue.location" />
          </gmap-map>

          <b-form-group label="Directions *" label-for="venueDirections">
            Provide a short description to help users find the location and parking only; driving directions are not necessary. Recommended: 100 characters or less.
            <b-form-input
              id="venueDirections"
              name="venueDirections"
              v-model="event.venue.directions"
              @input="dirty = true"
              :state="submitted && $v.event.venue.directions.$error ? false : null"
            />
            <small :class="event.venue.directions && event.venue.directions.length > 100 ? 'text-danger' : 'text-muted'">
              {{ event.venue.directions ? event.venue.directions.length : 0 }} characters
            </small>
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.venue.directions.required">Directions are required</b-form-invalid-feedback>
          </b-form-group>

          <TelephoneInput label="Phone Number" id="venuePhone" name="venuePhone" v-model="event.telephone" :submitted="submitted" />
          <!-- <b-form-group label="Phone Number" label-for="venuePhone">
            <b-form-input id="venuePhone" name="venuePhone" v-model="event.telephone" v-mask="'(###) ###-####'" type="tel"
              @input="dirty = true" />
          </b-form-group> -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <h1>Fees</h1>
          <b-form-group label="Is there a cost for admission? *" label-for="cost">
            <b-form-checkbox id="cost" name="cost" v-model="event.cost" @input="dirty = true" switch @change="feesUpdate" />
          </b-form-group>

          <b-form-group label="Fees *" label-for="fees" v-if="event.cost">
            <b-form-input id="fees" name="fees" v-model="event.fees" @input="dirty = true" :state="submitted && $v.event.fees.$error ? false : null" />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.fees.required">Fees are required</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Credit Cards Accepted" label-for="credit_cards" v-if="event.cost">
            <b-form-checkbox-group id="credit_cards" name="credit_cards" v-model="event.credit_cards" @input="dirty = true" class="cc-wrapper">
              <b-form-checkbox value="American Express"><font-awesome-icon :icon="['fab', 'cc-amex']" size="3x" /> American Express</b-form-checkbox>
              <b-form-checkbox value="Discover"><font-awesome-icon :icon="['fab', 'cc-discover']" size="3x" /> Discover</b-form-checkbox>
              <b-form-checkbox value="MasterCard"><font-awesome-icon :icon="['fab', 'cc-mastercard']" size="3x" /> MasterCard</b-form-checkbox>
              <b-form-checkbox value="Visa"><font-awesome-icon :icon="['fab', 'cc-visa']" size="3x" /> Visa</b-form-checkbox>
              <b-form-checkbox value="Apple Pay"><font-awesome-icon :icon="['fab', 'cc-apple-pay']" size="3x" /> Apple Pay</b-form-checkbox>
              <b-form-checkbox value="Google Pay"><font-awesome-icon :icon="['fab', 'google']" size="3x" /> Google Pay</b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <b-form-group label="Ticket Url" label-for="tickets_url">
            <b-form-input id="tickets_url" name="tickets_url" v-model="event.tickets_url" @input="dirty = true" />
            <b-form-invalid-feedback class="d-block red" v-if="this.event.tickets_url && !urlTest.test(this.event.tickets_url)"
              >Must include http:// or https://</b-form-invalid-feedback
            >
          </b-form-group>
        </div>
        <div class="col-lg-6">
          <h1>Dates</h1>
          <b-form-group label="Start Date *" label-for="startDate">
            <v-date-picker
              id="startDate"
              name="startDate"
              v-model="event.dateRange.start"
              :max-date="event.dateRange.end"
              :min-date="new Date()"
              @input="dirty = true"
              :state="submitted && $v.event.dateRange.start.$error ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.dateRange.start.required">Starting date is required</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="End Date *" label-for="endDate">
            <v-date-picker
              id="endDate"
              name="endDate"
              v-model="event.dateRange.end"
              :min-date="event.dateRange.start"
              @input="dirty = true"
              :state="submitted && $v.event.dateRange.end.$error ? false : null"
            />
            <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.dateRange.end.required">Ending date is required</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label="Time" label-for="time">
            <b-form-input id="time" name="time" v-model="event.time" @input="dirty = true" />
          </b-form-group>

          <b-form-group label="Repeating" label-for="repeating">
            <b-form-checkbox id="repeating" name="repeating" v-model="event.repeating" @input="dirty = true" />
          </b-form-group>

          <b-form-group label="Repeats" label-for="pattern" v-if="event.repeating">
            <b-form-select id="pattern" name="pattern" v-model="event.repeatDetails.pattern" @input="dirty = true">
              <option value="Weekly">Weekly</option>
              <option value="Monthly">Monthly</option>
            </b-form-select>

            Repeat every <b-form-input id="repeat_every" name="repeat_every" v-model="event.repeatDetails.every" type="number" min="0" @input="dirty = true" />
            {{ event.repeatDetails.pattern === 'Weekly' ? (event.repeatDetails.every === 1 ? 'week' : 'weeks') : event.repeatDetails.every === 1 ? 'month' : 'months' }}.

            <b-form-checkbox-group id="days" name="days" v-model="event.repeatDetails.days" @input="dirty = true">
              <b-form-checkbox value="Sunday">Sunday</b-form-checkbox>
              <b-form-checkbox value="Monday">Monday</b-form-checkbox>
              <b-form-checkbox value="Tuesday">Tuesday</b-form-checkbox>
              <b-form-checkbox value="Wednesday">Wednesday</b-form-checkbox>
              <b-form-checkbox value="Thursday">Thursday</b-form-checkbox>
              <b-form-checkbox value="Friday">Friday</b-form-checkbox>
              <b-form-checkbox value="Saturday">Saturday</b-form-checkbox>
            </b-form-checkbox-group>

            Expires <b-form-checkbox id="expires" name="expires" v-model="event.repeatDetails.expires" @input="dirty = true" switch />
            <span v-if="!event.repeatDetails.expires">Never</span>
            <span v-else>on <v-date-picker id="expiresOn" name="expiresOn" v-model="event.repeatDetails.expiresOn" :min-date="new Date()" @input="dirty = true" /></span>
          </b-form-group>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="col-lg-12 descriptions-section text-left">
            <h1>Descriptions</h1>
            <b-form-group label="Summary Description *" label-for="summary">
              Provide a short summary of your event that will appear in event search results. The summary should be 25 to 40 words.
              <b-form-textarea id="summary" name="summary" v-model="event.summary" rows="5" max-rows="5" :state="submitted && $v.event.summary.$error ? false : null" />
              <small :class="summaryWordCount > 40 ? 'text-danger' : 'text-muted'" class="d-block text-right">
                {{ summaryWordCount }} / 40 words
              </small>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.summary.required">Summary is required</b-form-invalid-feedback>
            </b-form-group>
          </div>
          <div class="col-lg-12 text-left">
            <b-form-group label="Event Description *" label-for="description" class="text-left contentField">
              The Event Description should provide full detail of your event for users including expected activities, event details, and other relevant information for planning and attending the event.
              <froala
                id="description"
                :tag="'textarea'"
                :config="config"
                v-model="event.description"
                @input="dirty = true"
                :state="submitted && $v.event.description.$error ? false : null"
              />
              <small :class="descriptionWordCount > 150 ? 'text-danger' : 'text-muted'" class="d-block text-right">
                {{ descriptionWordCount }} / 150 words
              </small>
              <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.description.required">Description is required</b-form-invalid-feedback>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="categories-section">
        <h1>Categories *</h1>
        <b-form-group>
          <b-form-checkbox-group
            id="categories"
            name="categories"
            v-model="event.categories"
            @input="dirty = true"
            buttons
            :state="submitted && $v.event.categories.$error ? false : null"
          >
            <b-form-checkbox value="Alabama Maker" class="rounded-pill">Alabama Maker</b-form-checkbox>
            <b-form-checkbox value="Arts and culture" class="rounded-pill">Arts and culture</b-form-checkbox>
            <b-form-checkbox value="BBQ" class="rounded-pill">BBQ</b-form-checkbox>
            <b-form-checkbox value="Business and networking" class="rounded-pill">Business and networking</b-form-checkbox>
            <b-form-checkbox value="Civic and local" class="rounded-pill">Civic and local</b-form-checkbox>
            <b-form-checkbox value="Civil Rights" class="rounded-pill">Civil Rights</b-form-checkbox>
            <b-form-checkbox value="Collectibles and special interest" class="rounded-pill">Collectibles and special interest</b-form-checkbox>
            <b-form-checkbox value="Community festival" class="rounded-pill">Community festival</b-form-checkbox>
            <b-form-checkbox value="Cultural festival" class="rounded-pill">Cultural festival</b-form-checkbox>
            <b-form-checkbox value="Education" class="rounded-pill">Education</b-form-checkbox>
            <b-form-checkbox value="Entertainment and nightlife" class="rounded-pill">Entertainment and nightlife</b-form-checkbox>
            <b-form-checkbox value="Food and drink" class="rounded-pill">Food and drink</b-form-checkbox>
            <b-form-checkbox value="Golf" class="rounded-pill">Golf</b-form-checkbox>
            <b-form-checkbox value="History and heritage" class="rounded-pill">History and heritage</b-form-checkbox>
            <b-form-checkbox value="Holiday and seasonal" class="rounded-pill">Holiday and seasonal</b-form-checkbox>
            <b-form-checkbox value="Music festival" class="rounded-pill">Music festival</b-form-checkbox>
            <b-form-checkbox value="Outdoor" class="rounded-pill">Outdoor</b-form-checkbox>
            <b-form-checkbox value="Shopping" class="rounded-pill">Shopping</b-form-checkbox>
            <b-form-checkbox value="Sports and recreation" class="rounded-pill">Sports and recreation</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <b-form-invalid-feedback class="d-block red" v-if="submitted && !$v.event.categories.required">A category is required</b-form-invalid-feedback>
      </div>

      <div class="experiences-section">
        <h1>Experiences *</h1>
        <b-form-group>
          <b-checkbox-group id="experiences" name="experiences" v-model="event.experiences_ids" buttons :state="submitted && event.experiences_ids.length < 1 ? false : null">
            <b-checkbox :value="4" class="rounded-pill">Arts &amp; Culture</b-checkbox>
            <b-checkbox :value="2" class="rounded-pill">Beaches</b-checkbox>
            <b-checkbox :value="5" class="rounded-pill">Civil Rights</b-checkbox>
            <b-checkbox :value="3" class="rounded-pill">Food &amp; Drink</b-checkbox>
            <b-checkbox :value="1" class="rounded-pill">History</b-checkbox>
            <b-checkbox :value="6" class="rounded-pill">Music</b-checkbox>
            <b-checkbox :value="8" class="rounded-pill">Outdoors</b-checkbox>
            <b-checkbox :value="9" class="rounded-pill">Science &amp; Discovery</b-checkbox>
            <b-checkbox :value="10" class="rounded-pill">Sports</b-checkbox>
            <b-checkbox :value="7" class="rounded-pill">Year Round Golf</b-checkbox>
          </b-checkbox-group>
          <b-form-invalid-feedback class="d-block red" v-if="submitted && event.experiences_ids.length < 1">At least 1 Experience is required</b-form-invalid-feedback>
        </b-form-group>
      </div>

      <div class="badges-section" v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor'">
        <h1>Badges</h1>
        <b-form-group v-if="badgeOptions">
          <b-form-checkbox-group id="badges" name="badges" class="badge-wrap" v-model="event.badges" @input="dirty = true" buttons>
              <b-form-checkbox v-for="badge in badgeOptions" :value="badge.value" v-bind:key="badge.value" class="text-center">
                <img :alt="badge.text" :src="badge.imageUrl" class="badge-img" />{{ badge.text }}
                </b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <h1>Images</h1>
          <div class="image-message">
            The more images you have the better. You should have a minimum of one image that will be shown at the top of the page known as the
            <span class="bold-text">featured image</span>. We would prefer you to have at least 5 or 6 images. There is a minimum of 5 images for the
            <span class="bold-text">image ribbon</span> to appear. If adding multiple images, you must check one of the images as <span class="bold-text">featured.</span> Only jpg,
            jpeg, gif, and png are accepted at this time.
          </div>
        </div>
        <figure class="col-lg-6">
          <img src="/images/mock.png" class="mock img-fluid" alt="Example of detail page layout" />
        </figure>
        <div class="col-lg-6 mt-5">
          <!-- Images Component -->
          <photos :files="event.photos" type="Event" v-on:updateFiles="updatePhotos" v-on:featuredImageChanged="checkShowFeaturedImageNotification" ref="photoUpload" />
        </div>
        <div v-if="showFeaturedImageNotification" class="mb-4 featured-image-notification">
                  You have removed your featured image. Please select another image from the other photos here to be your new featured image.
                  This image will be the first image users see when they land on your listing and will also be featured along with other listings in feature cells across the site.
                  If you do not select one then we will automatically assign one.
                </div>
      </div>
      <template v-if="!isLoading">
        <div v-if="$store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor' || !event.pendingChangeRequest">
          <b-button class="mr-1 btn-white" @click="$router.go(-1)">Cancel</b-button>
          <b-button class="ml-1" @click="saveEvent()">Save</b-button>
        </div>
      </template>
      <template v-if="isLoading">
        <b-button class="btn disabled">Submitting...</b-button>
      </template>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { required, requiredIf } from 'vuelidate/lib/validators';
import { extractDigits } from '@/lib/functions/phoneNumber';
import photos from '../../components/Photos.vue';
import TelephoneInput from '../../components/TelephoneInput.vue';

const notZero = (value) => value !== 0;

export default {
  components: {
    photos,
    TelephoneInput,
  },
  data() {
    return {
      userOrgs: [],
      locations: [],
      urlTest: /(http(s?)):\/\//i,
      locationSelected: {
        name: '',
      },
      showFeaturedImageNotification: false,
      event: {
        venue_id: null,
        organization_id: null,
        pendingChangeRequest: null,
        changeRequestId: null,
        changeRequest: null,
        changeRequestType: null,
        name: null,
        publish: null,
        slug: null,
        categories: [],
        badges: [],
        social_networks: {},
        social_networks_to_save: [],
        website: null,
        telephone: '',
        counties: [],
        description: null,
        summary: null,
        dateRange: {
          start: new Date(),
          end: null,
        },
        time: null,
        repeating: false,
        repeatDetails: {
          pattern: 'Weekly',
          every: null,
          days: [],
          expires: false,
          expiresOn: null,
        },
        venue: {
          googlePlaceId: 0,
          location: { lat: 0, lng: 0 },
          directions: null,
          telephone: null,
          address: null,
          city: null,
          zip: null,
        },
        cost: 0,
        fees: 0,
        credit_cards: [],
        tickets_url: null,
        photos: [],
        experiences: [],
        experiences_ids: [],
      },
      saved: true,
      map: {
        zoom: 6,
        center: {
          lat: 33,
          lng: -86.8104,
        },
      },
      badgeOptions: [],
      dirty: false,
      version: 0,
      submitted: false,
      isLoading: false,
      config: {
        key: `${process.env.VUE_APP_FROALA}`,
        heightMax: 150,
        toolbarButtons: ['bold', 'italic', 'underline', '|', 'align', 'formatOL', 'formatUL', 'outdent', 'indent', '-', 'insertLink', '|', 'html', '|', 'undo', 'redo'],
        events: {},
      },
      customToolbar: [['bold', 'italic', 'underline'], [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }], ['code-block']],
    };
  },
  props: {
    eventId: {
      type: String,
    },
  },
  validations: {
    event: {
      organization_id: {
        required,
      },
      name: {
        required,
      },
      categories: {
        required,
      },
      dateRange: {
        start: {
          required,
        },
        end: {
          required,
        },
      },
      description: {
        required,
      },
      counties: {
        required,
      },
      summary: {
        required,
      },
      venue: {
        directions: {
          // required: requiredIf(event => event.venue_id),
          required,
        },
        location: {
          lat: {
            required,
            notZero,
          },
        },
        address: {
          required,
        },
        zip: {
          required,
        },
      },
      cost: {
        required,
      },
      fees: {
        required: requiredIf((event) => event.cost === true),
      },
    },
  },
  computed: {
    summaryWordCount() {
      if (!this.event.summary) return 0;
      return this.event.summary.trim().split(/\s+/).filter(Boolean).length;
    },
    descriptionWordCount() {
      if (!this.event.description) return 0;
      const stripped = this.event.description.replace(/<[^>]*>/g, ' ');
      return stripped.trim().split(/\s+/).filter(Boolean).length;
    },
  },
  async created() {
    await Promise.all([this.getLocations(), this.getBadges(), this.getSocialNetworks(), this.getEventDetails(), this.getOrganizations()]);
  },
  methods: {
    feesUpdate() {
      if (this.event.cost === true) {
        this.event.fees = '';
        this.event.credit_cards = [];
      }
    },
    selectedLocation(location) {
      this.event.venue_id = location.selectedObject._id;
      this.event.venue.address = location.selectedObject.address;
      this.event.venue.city = location.selectedObject.city;
      this.event.venue.zip = location.selectedObject.zip;
      this.event.venue.location.lat = parseFloat(location.selectedObject.latitude, 10);
      this.event.venue.location.lng = parseFloat(location.selectedObject.longitude, 10);
      this.locationSelected.name = location.selectedObject.name;
      this.map.center = this.event.venue.location;
      this.map.zoom = 13;
    },
    clearSelectedLocation() {
      this.event.venue_id = '';
      this.event.venue.address = '';
      this.event.venue.city = '';
      this.event.venue.zip = '';
      this.event.venue.location.lat = 33.137764;
      this.event.venue.location.lng = -86.771363;
      this.event.venue.directions = '';
      this.locationSelected.name = '';
      this.map.zoom = 6;
    },
    formattedDisplay(result) {
      return `${result.name} -- ${result.city}`;
    },
    async cancelChangeRequest(changeRequestId) {
      const response = await axios.get(`${process.env.VUE_APP_API_ROOT}/admin/cancelChangeRequest/${changeRequestId}`);
      if (response.data.success) {
        this.event.pendingChangeRequest = false;
        this.event.changeRequestId = null;
        this.$bvToast.toast(`${response.data.message}`, {
          title: 'Success',
          autoHideDelay: 5000,
          appendToast: true,
        });
      } else {
        this.$bvToast.toast(`${response.data.message}`, {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
      }
    },
    updatePhotos(photoFiles) {
      this.event.photos = photoFiles;
    },
    async generateSlug() {
      if (!this.eventId && this.event.name !== '') {
        const response = await axios.post(`${process.env.VUE_APP_API_EVENTS_ROOT}/generateSlug`, { name: this.event.name });
        this.event.slug = response.data;
      }
    },
    async getBadges() {
      if (this.$store.state.misc.badges && this.$store.state.misc.badges.length === 0) {
        await this.$store.dispatch('misc/getBadges');
      }
      this.badgeOptions = this.$store.state.misc.badges.map((b) => ({
        text: b.name,
        value: b._id,
        imageUrl: `https://alabama-travel.s3.amazonaws.com/partners-uploads/badge/image/${b._id}/${b.image}`,
      }));
    },
    async getSocialNetworks() {
      if (this.$store.state.misc.social_networks && this.$store.state.misc.social_networks.length === 0) {
        await this.$store.dispatch('misc/getSocialNetworks');
      }
    },
    async getLocations() {
      const locationsResponse = await axios.get(`${process.env.VUE_APP_API_LOCATIONS_ROOT}/locations/lean`);
      this.locations = locationsResponse.data.locations;

      if (this.event.venue_id) {
        // find the location by searcting locationss array, return a match that matches the this.event.venue_id.
        const location = this.locations.find((l) => l._id === this.event.venue_id);
        this.locationSelected.name = location.name;
      }
    },
    async getEventDetails() {
      if (!this.eventId) {
        return;
      }
      if (this.eventId) {
        const eventResponse = await axios.get(`${process.env.VUE_APP_API_EVENTS_ROOT}/events/${this.eventId}`);
        const socialNetworks = {};
        if (eventResponse.data.social_networks) {
          for (let i = 0; i < eventResponse.data.social_networks.length; i++) {
            socialNetworks[eventResponse.data.social_networks[i].network_name] = eventResponse.data.social_networks[i];
          }
        }
        this.event = {
          pendingChangeRequest: eventResponse.data.pendingChangeRequest,
          changeRequestId: eventResponse.data.changeRequestId ? eventResponse.data.changeRequestId : null,
          changeRequest: eventResponse.data.changeRequest,
          changeRequestType: eventResponse.data.changeRequestType,
          name: eventResponse.data.name,
          publish: eventResponse.data.publish,
          slug: eventResponse.data.slug,
          categories: eventResponse.data.categories,
          website: eventResponse.data.website,
          description: eventResponse.data.description,
          telephone: extractDigits(eventResponse.data.telephone || ''),
          summary: eventResponse.data.summary,
          dateRange: {
            start: new Date(eventResponse.data.start_on),
            end: new Date(eventResponse.data.end_on),
          },
          time: eventResponse.data.time,
          repeating: eventResponse.data.repeating,
          repeatDetails: eventResponse.data.repeating
            ? {
              pattern: eventResponse.data.repeats,
              every: eventResponse.data.repeat_frequency,
              days: eventResponse.data.repeat_day_of_week ? eventResponse.data.repeat_day_of_week.split(',') : '',
              expires: eventResponse.data.repeat_ending_date !== null,
              expiresOn: new Date(eventResponse.data.repeat_ending_date),
            }
            : {},
          venue: {
            directions: eventResponse.data.directions,
            googlePlaceId: eventResponse.data.googlePlaceId,
            location: { lat: parseFloat(eventResponse.data.latitude, 10), lng: parseFloat(eventResponse.data.longitude, 10) },
            address: eventResponse.data.address,
            city: eventResponse.data.city,
            zip: eventResponse.data.zip,
            telephone: extractDigits(eventResponse.data.phone),
          },
          cost: eventResponse.data.cost === 'Admission Charged',
          fees: eventResponse.data.fees,
          credit_cards: eventResponse.data.credit_cards,
          tickets_url: eventResponse.data.tickets_url,
          photos: eventResponse.data.photos,
          social_networks: socialNetworks,
          badges: eventResponse.data.badges ? eventResponse.data.badges : [],
          organization_id: eventResponse.data.organization_id,
          counties: eventResponse.data.counties,
          venue_id: eventResponse.data.venue_id,
          experiences_ids: eventResponse.data.experiences_ids,
        };
        this.map.center = this.event.venue.location;
        this.map.zoom = 13;
      }
      if (this.event.venue_id && this.locations && this.locations.length > 0) {
        const locationName = this.locations.filter((l) => l._id === this.event.venue_id)[0].name;
        if (locationName) {
          this.locationSelected.name = locationName;
        }
      }

      if (this.event.venue && this.event.venue.googlePlaceId) {
        this.map.zoom = 13;
        this.map.center = this.event.venue.location;
      } else if (this.event.venue.address) {
        this.$refs.address.$el.focus();
      }
    },
    async getOrganizations() {
      const isPartner = this.$store.state.auth.user.role === 'partner' || this.$store.state.auth.user.role === 'dmo' || this.$store.state.auth.user.role === 'user';
      const response = await axios.get(`${process.env.VUE_APP_API_ORGANIZATIONS_ROOT}/${isPartner ? `getOrgsForUser/${this.$store.state.auth.mUser._id}` : 'organizations/lean'}`);
      const orgs = isPartner ? response.data.userOrganizations : response.data.organizations;
      this.userOrgs = orgs.map((o) => ({ text: o.name, value: o._id }));
    },
    checkShowFeaturedImageNotification(updatedPhotos) {
      this.showFeaturedImageNotification = false;

      if (updatedPhotos.length > 0 && !updatedPhotos.some(x => x.featured)) {
        this.showFeaturedImageNotification = true;
      }
    },
    setPlace(place) {
      this.event.venue.googlePlaceId = place.place_id;
      this.event.venue.location = { lat: place.geometry.location.lat(), lng: place.geometry.location.lng() };
      this.map.center = this.event.venue.location;
      this.map.zoom = 13;
      this.event.venue.phone = place.formatted_phone_number;

      let streetNumber = place.address_components.find((a) => a.types.includes('street_number'));
      streetNumber = streetNumber ? streetNumber.long_name : '';
      let streetName = place.address_components.find((a) => a.types.includes('route'));
      streetName = streetName ? streetName.long_name : '';
      this.event.venue.address = `${streetNumber} ${streetName}`;

      let city = place.address_components.find((a) => a.types.includes('locality'));
      city = city ? city.long_name : '';
      this.event.venue.city = city;

      let postal = place.address_components.find((a) => a.types.includes('postal_code'));
      postal = postal ? postal.long_name : '';
      this.event.venue.zip = postal;
    },
    async saveEvent() {
      this.submitted = true;
      this.isLoading = true;
      this.$v.$touch();
      const photosValid = this.$refs.photoUpload.validatePhotos();
      if (this.$v.$invalid || this.event.experiences_ids.length < 1 || !photosValid) {
        this.$bvToast.toast('Missing Required Fields', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }
      const regEx = /(http(s?)):\/\//i;
      if (this.event.website && !regEx.test(this.event.website)) {
        const message = 'Website URL must include http:// or https://';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }
      if (this.event.tickets_url && !regEx.test(this.event.tickets_url)) {
        const message = 'Ticket URL must include http:// or https://';
        this.$bvToast.toast(message, {
          title: 'Error',
          autoHideDelay: 8000,
          appendToast: true,
        });
        this.isLoading = false;
        return;
      }

      const eventNetworksRefs = this.$refs.eventNetwork;
      const facebookRegEx = /(https:\/\/(www.)?facebook.com\/)/i;
      const twitterRegEx = /(https:\/\/(www.)?twitter.com\/)/i;
      const instagramRegEx = /(http(s?)):\/\/(www\.)?instagram.com/i;
      const eventNetworks = [];

      eventNetworksRefs.forEach((eventNetwork) => {
        if (eventNetwork.$attrs['data-networkname'] === 'Facebook') {
          eventNetworks.push({
            social_network_id: eventNetwork.$attrs['data-networkid'],
            account_name: eventNetwork.localValue.replace(facebookRegEx, ''),
            event_id: this.eventId,
          });
        }
        if (eventNetwork.$attrs['data-networkname'] === 'Twitter') {
          eventNetworks.push({
            social_network_id: eventNetwork.$attrs['data-networkid'],
            account_name: eventNetwork.localValue.replace(twitterRegEx, ''),
            event_id: this.eventId,
          });
        }
        if (eventNetwork.$attrs['data-networkname'] === 'Instagram') {
          eventNetworks.push({
            social_network_id: eventNetwork.$attrs['data-networkid'],
            account_name: eventNetwork.localValue.replace(instagramRegEx, ''),
            event_id: this.eventId,
          });
        }
      });
      this.event.social_networks_to_save = eventNetworks;

      await this.$refs.photoUpload.uploadFiles();
      const url = this.eventId ? `${process.env.VUE_APP_API_EVENTS_ROOT}/events/${this.eventId}` : `${process.env.VUE_APP_API_EVENTS_ROOT}/events`;
      try {
        const response = await axios.post(url, { ...this.event, cost: this.event.cost ? 'Admission Charged' : 'Free' });
        if (response.data.success) {
          this.dirty = false;
          this.version = response.data;
          const self = this;
          if (this.eventId || this.$store.state.auth.user.role === 'admin' || this.$store.state.auth.user.role === 'editor' || this.$store.state.auth.user.role === 'limited_editor') {
            this.$router.push({ name: 'event detail', params: { eventId: response.data.eventId } }, () => {
              setTimeout(() => {
                self.$bvToast.toast(`${JSON.stringify(response.data.message)}`, { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          } else {
            this.$router.push({ name: 'event list' }, () => {
              setTimeout(() => {
                self.$bvToast.toast(`${JSON.stringify(response.data.message)}`, { title: 'Success', autoHideDelay: 5000, appendToast: true });
              }, 500);
            });
          }
        } else {
          this.$bvToast.toast(`${JSON.stringify(response.data.message)}`, {
            title: 'Error',
            autoHideDelay: 5000,
            appendToast: true,
          });
          this.isLoading = false;
        }
      } catch (err) {
        this.$bvToast.toast('Something went wrong.', {
          title: 'Error',
          autoHideDelay: 5000,
          appendToast: true,
        });
        this.isLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.bold-text {
  font-weight: bold;
}

.featured-image-notification {
  border-radius: var(--rounded-lg);
  padding: 8px 24px 8px 24px;
  background-color: #E5F5FD;
}

.descriptions-section .form-group {
  width: 60%;
}

.form-group >>> div {
  font-size: 14px;
  color: #666666;
}

div.image-desc {
  width: 60%;
  font-size: 14px;
}

.tab-pane {
  margin-top: 20px;
}

.d-block {
  font-weight: 700;
}

.thumbnail-image {
  width: 100%;
}

.upload-wrapper {
  border-bottom: 1px solid #cccccc;
  padding: 10px 0;
  margin: 10px 0;
}

.upload-wrapper:last-of-type {
  border-bottom: none;
}

.file-name {
  font-size: 14px;
  line-height: 2rem;
}

.custom-control {
  margin: 10px 0;
}

.custom-control-label {
  margin-right: 15px;
}

.categories-section >>> .btn-secondary {
  background-color: white;
  color: black;
  font-weight: 500;
  border: 1px solid #4e97b2;
  margin: 0px 20px 10px 0;
  min-width: 175px;
}

.categories-section >>> .btn-secondary.active {
  background-color: #4e97b2;
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.categories-section >>> .btn-group {
  display: inline;
}

.cc-wrapper >>> .custom-control {
  width: 40%;
  border-radius: var(--rounded-xl);
  margin-right: 5%;
}

.badges-section >>> .btn-secondary {
  background-color: white;
  color: black;
  border-radius: var(--rounded-xl);
  border-top-right-radius: 10px !important;
  border-bottom-right-radius: 10px !important;
  font-weight: 500;
  margin: 0px 20px 10px 0;
  width: 175px;
  text-align: center;
  display: block;
  flex: 0;
}

.badges-section >>> .btn-secondary.active {
  background-color: white;
  border: 1px solid #4e97b2;
  color: black;
}

.badges-section >>> .btn-secondary:hover {
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.badge-wrap {
  display: flex;
  flex-wrap: wrap;
}

.badge-img {
  width: 140px;
  display: block;
  margin-left: 0%;
  margin-bottom: 10px;
}

.cc-wrapper >>> .svg-inline--fa {
  vertical-align: middle;
  margin-right: 10px;
}

.availability-section >>> .custom-control-inline {
  width: 30%;
  margin-bottom: 10px;
}

.availability-section >>> .custom-control-inline:last-of-type {
  width: 50%;
}

.experiences-section >>> .btn-secondary {
  background-color: white;
  color: black;
  font-weight: 500;
  border: 1px solid #4e97b2;
  margin: 0px 20px 10px 0;
  min-width: 175px;
}

.experiences-section >>> .btn-group {
  display: inline;
}

.experiences-section >>> .btn-secondary.active {
  background-color: #4e97b2;
  border: 1px solid #4e97b2;
  -webkit-box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
  box-shadow: 5px 5px 15px 0px rgba(0, 0, 0, 0.18);
}

.image-message {
  font-size: 18px;
}

.mock {
  bottom: 0;
  position: absolute;
  right: 0;
  top: 100px;
}

.red {
  color: #dc3545 !important;
}
</style>
